export default __webpack_public_path__ + "static/media/services_trans_1.b96da699.jpg";